import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Global Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Public Page Imports
import Home from './pages/Home';
import ServicesPage from './pages/ServicesPage';
import PortfolioPage from './pages/PortfolioPage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import BrandingProductsPage from './pages/BrandingProductsPage';
import BlogPage from './pages/BlogPage';
import SingleBlogPage from './pages/SingleBlogPage';

// Admin Dashboard Imports
import AdminLogin from './admin/AdminLogin';
import CreatePost from './admin/CreatePost';
import ReviewPosts from './admin/ReviewPosts';
import AuthorDashboard from './admin/AuthorDashboard';
import EditPost from './admin/EditPost';

// We create an inner component so we can use the "useLocation" hook (which requires a Router parent)
const AppContent = ({ authToken, setAuthToken }) => {
  const location = useLocation();

  // Check if the current URL starts with "/admin"
  const isAdminRoute = location.pathname.startsWith('/admin') && location.pathname !== '/admin/login';

  return (
    <div className="font-sans overflow-x-hidden bg-brand-light min-h-screen flex flex-col">
      {/* Only show the public Navbar if we are NOT on an admin route */}
      {!isAdminRoute && <Navbar />}

      {/* Main Content Area */}
      <main className="flex-grow">
        <Routes>
          {/* --- PUBLIC ROUTES --- */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/:id" element={<ServiceDetailPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/promotional-products" element={<BrandingProductsPage />} />
          <Route path="/promotional-products/:categorySlug" element={<BrandingProductsPage />} />

          {/* Blog Routes */}
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<SingleBlogPage />} />

          {/* --- SECURE ADMIN ROUTES --- */}
          <Route path="/admin/login" element={<AdminLogin setAuthToken={setAuthToken} />} />

          {/* Author Routes */}
          <Route path="/admin/dashboard" element={<AuthorDashboard token={authToken} setAuthToken={setAuthToken} />} />
          <Route path="/admin/create-post" element={<CreatePost token={authToken} setAuthToken={setAuthToken} />} />

          {/* Admin Manager Routes */}
          <Route path="/admin/review-posts" element={<ReviewPosts token={authToken} setAuthToken={setAuthToken} />} />
          <Route path="/admin/edit-post/:id" element={<EditPost token={authToken} setAuthToken={setAuthToken} />} />
        </Routes>
      </main>

      {/* Only show the public Footer if we are NOT on an admin route */}
      {!isAdminRoute && <Footer />}
    </div>
  );
};

function App() {
  // To this:
  const [authToken, setAuthToken] = useState(localStorage.getItem('token') || '');

  return (
    <HelmetProvider>
      <Router>
        <AppContent authToken={authToken} setAuthToken={setAuthToken} />
      </Router>
    </HelmetProvider>
  );
}

export default App;